import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ContentOrderFilter = (props) => {
  const {
    contentOrders,
    filterName,
    setFilter,
    resetFilter
  } = props;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedName, setSelectedName] = useState(null);

  const toggle = () => setDropdownOpen(!dropdownOpen);

  const uniqueNames = Array.from(
    new Map(
      contentOrders.map(order => [
        order.meta.project.meta.parent['_id'],
        order.meta.project.meta.parent.local.business.name.trim()
      ]).map(([id, name]) => [id, [id, name]])
    ).values()
  ).sort(function (a, b) {
    return a[1].localeCompare(b[1]);
  });

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret>
        {filterName || "Select Name"}
      </DropdownToggle>
      <DropdownMenu>
        {filterName && (
          <span>
            <DropdownItem
              onClick={() => {
                resetFilter();
              }}
            >
              Reset Filter
            </DropdownItem>
            <DropdownItem divider />
          </span>
        )}

        {uniqueNames.length === 0 ? (
          <DropdownItem disabled>
            None
          </DropdownItem>
        ) : (
          uniqueNames.map(([id, name]) => (
            <DropdownItem
              key={id}
              onClick={() => {
                setSelectedName(name);
                setFilter(name)
              }}
            >
              {name}
            </DropdownItem>
          ))
        )}
      </DropdownMenu>

      {filterName && (
        <span>
          <FontAwesomeIcon
            className="ml-2"
            icon={faTimes}
            onClick={() => {
              resetFilter();
            }}
          />
        </span>
      )}
    </Dropdown>
  );
};

export default ContentOrderFilter;
